import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=c8c74a52&"
import script from "./Timetable.vue?vue&type=script&lang=js&"
export * from "./Timetable.vue?vue&type=script&lang=js&"
import style0 from "./Timetable.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports